import { render, staticRenderFns } from "./BreadTabulatorFormChildSelectModel.vue?vue&type=template&id=412593ce&"
import script from "./BreadTabulatorFormChildSelectModel.vue?vue&type=script&lang=js&"
export * from "./BreadTabulatorFormChildSelectModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
